// @flow
import { makeApiCall } from "../../../../services/apiService/apiService";

export const ticketingCcModalActions = {
  GET_EMAIL_CC_OPTIONS: "GET_EMAIL_CC_OPTIONS"
};

export const getEmailCcOptionsAction = (data: boolean) => ({
  type: ticketingCcModalActions.GET_EMAIL_CC_OPTIONS,
  payload: data
});

const emailCcOptionsDefaultAction = () => (dispatch: Function) => {
  dispatch(
    getEmailCcOptionsAction({
      isLoading: false,
      isLoaded: true,
      data: []
    })
  );
};

export const getEmailCcOptions = text => (dispatch: Function) => {
  dispatch(
    getEmailCcOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketingUsers",
    replaceParamsArr: [{ key: "searchText", val: text }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched email cc options ", res);
      if (res.status === "SUCCESS") {
        const data = {
          isLoading: false,
          isLoaded: true,
          data: res.response
        };
        dispatch(getEmailCcOptionsAction(data));
      } else if (res.status === "FAILURE") {
        dispatch(emailCcOptionsDefaultAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in email cc options, res= ", res);
      dispatch(emailCcOptionsDefaultAction());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in email cc options ", res);
      dispatch(emailCcOptionsDefaultAction());
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/commons/ticketingCcModal/ticketingCcModalRedux/ticketingCcModalActionCreator.js